interface SubscriptionProviderProps {
  id: string;
  name: string;
}

class SubscriptionProvider {
  constructor(public _: SubscriptionProviderProps) {}

  static paddle = new SubscriptionProvider({
    id: "paddle",
    name: "Paddle",
  });

  static internal = new SubscriptionProvider({
    id: "internal",
    name: "Internal",
  });

	static unknown = new SubscriptionProvider({
		id: "unknown",
		name: "Unknown",
	});

  static fromId(id: string) {
    if (id === SubscriptionProvider.paddle._.id) return SubscriptionProvider.paddle;
    if (id === SubscriptionProvider.internal._.id) return SubscriptionProvider.internal;
    return SubscriptionProvider.unknown;
  }
}

export { SubscriptionProvider };
